import React, { useEffect, useState } from 'react';
import { Link } from 'react-scroll';

const Navbar = () => {
  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Hide navbar if scrolling down
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setShowNavbar(false);
      }
      // Show navbar if scrolling up by at least 10px
      else if (currentScrollY < lastScrollY - 5) {
        setShowNavbar(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    <nav
      className={`fixed top-0 w-full z-50 py-5 transition-opacity duration-300 ${
        showNavbar ? 'opacity-100' : 'opacity-0 pointer-events-none'
      }`}
      aria-hidden={!showNavbar}
    >
      <div className="container mx-auto flex justify-center">
        <ul className="flex space-x-4 sm:space-x-8 md:space-x-12 lg:space-x-20">
          {['Home', 'About', 'Recordings', 'Videos', 'Teaching', 'Contact'].map((section) => (
            <li key={section}>
              <Link
                to={section === 'Home' ? 'header' : section.toLowerCase()}
                smooth={true}
                duration={500}
                className="text-sm sm:text-base md:text-lg cursor-pointer hover:text-gray-300"
                style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  color: '#f7f6ef',
                  textShadow: '2px 2px 6px rgba(0, 0, 0, 0.7)',
                }}
              >
                {section}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
